import React from 'react';

import { Slider } from '@eliadmin/core/src/components/ui/slider';
import { useCategoryStore } from '@eliadmin/core/src/stores/category-store';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function AttributePrice() {
  const max = useCategoryStore(state => state.category?.price?.max) ?? 9;
  const min = useCategoryStore(state => state.category?.price?.min) ?? 0;

  const clearTrigger = useCategoryStore(state => state.clearTrigger);
  const setFilter = useCategoryStore(state => state.setFilter);

  const [priceRange, setPriceRange] = React.useState<number[]>([min, max]);

  React.useEffect(() => {
    setPriceRange([min, max]);
  }, [min, max, clearTrigger]);

  const handlePriceChange = () => {
    setFilter({ price_min: priceRange[0], price_max: priceRange[1] });
  };

  // If you truly want to hide when "max is not available", check the raw value:
  const rawMax = useCategoryStore(state => state.category?.price?.max);
  if (rawMax == null) return null;

  return (
    <div className={cn('flex flex-col gap-4 px-2 pb-2 pt-3', 'ea-attribute-price')}>
      <Slider
        isDual
        value={priceRange}
        min={min}
        max={max}
        aria-label="Price range"
        onValueChange={value => setPriceRange(value)}
        onBlur={handlePriceChange}
      />
      <div
        className={cn('flex w-full flex-row justify-between gap-2', 'ea-attribute-price__wrapper')}
      >
        <p>{priceRange[0]}</p>
        <p>{priceRange[1]}</p>
      </div>
    </div>
  );
}
